class BundleDetails extends HTMLElement {
    constructor() {
      super();
      this.details = this.querySelector('details');
      this.gid = this.closest(".product-card-wrapper")?.dataset.gid;
      this.storeUrl = this.closest(".product-card-wrapper")?.dataset.storeUrl; 
      this.bundleList = this.closest(".product-card-wrapper").querySelector(".badge__bundle-list");
  
      this.details.addEventListener("toggle", () => {
        if (this.details.closest(".product-card-wrapper")) {
          if (this.details.hasAttribute("open")) {
            this.details.closest(".product-card-wrapper").parentNode.classList.add("product-card-modal-open");
            if (this.gid && this.bundleList) this.retrieveBundle();
          } else {
            this.details.closest(".product-card-wrapper").parentNode.classList.remove("product-card-modal-open");
            if (this.gid && this.bundleList) this.bundleList.innerHTML = '';
          }
        }
      })
  
      if (window.matchMedia('(hover: hover)').matches) {
        this.details.addEventListener('mouseenter', this.onHoverOpen.bind(this));
        this.details.addEventListener('mouseleave', this.onHoverClose.bind(this));
      }
    }
  
    onHoverOpen() {
      this.details.setAttribute('open', '');
      this.details.querySelector('summary').setAttribute('aria-expanded', true);
    }
  
    onHoverClose() {
      this.details.removeAttribute('open');
      this.details.querySelector('summary').setAttribute('aria-expanded', false);
    }
  
    async retrieveBundle() {
      const query = `query getBundleData($id: ID!) {
        product(id: $id) {
          selectedOrFirstAvailableVariant {
            components(first: 50) {
              nodes {
                productVariant {
                  product {
                    title
                    handle
                  }
                }
              }
            }
          }
        }
      }`;
      const result = await fetch(`https://${Shopify.shop}/api/2024-10/graphql.json`, {
        method: "POST",
        headers: {
          "content-type": "application/json",
          "X-Shopify-Storefront-Access-Token": window.tokenBundles,
        },
        body: JSON.stringify({
          query: query,
          variables: {
            id: this.gid
          }
        })
      })
      const data = await result.json()
      if (data && data.data.product.selectedOrFirstAvailableVariant.components.nodes) {
        data.data.product.selectedOrFirstAvailableVariant.components.nodes.forEach(node => {
            const product = node.productVariant.product;
            const productUrl = `${this.storeUrl}products/${product.handle}`;
            const title = product.title || "";
            const productHtml = `
                <li><a href="${productUrl}" class="low-xs font-heading unstyled-link">${title}</a></li>
            `;

            this.bundleList.insertAdjacentHTML("beforeend", productHtml);
        });
    }
  }
}
  
customElements.define('bundle-details', BundleDetails);